<template>
	<transition name="dialog-t">
		<div
			v-if="isPrompt ? active : fActive"
			ref="con"
			:class="[`vs-dialog-${color}`]"
			class="vs-component con-vs-dialog con-vs-dialog-custom"
		>
			<div
				class="vs-dialog-dark"
				@click="handleClose($event,true)"
			/>
			<div
				ref="dialogx"
				class="vs-dialog"
			>

				<!-- //header -->
				<header
					:style="styleHeader"
					class="vs-dialog-header"
				>
					<div class="con-title-after">
						<span
							:style="styleAfter"
							class="after"
						/>
						<h3 class="dialog-title">{{ title }} </h3>
						<div
							:class="[`vs-tabs-${tabColor}`,`vs-tabs-position-${tabPosition}`]"
							class="con-vs-tabs vs-tabs"
						>
							<div class="con-ul-tabs">
								<ul
									ref="ul"
									:class="[`ul-tabs-${tabAlignment}`]"
									class="ul-tabs vs-tabs--ul"
								>
									<li
										v-for="(child, index) in tabChildrenSlots"
										ref="li"
										:class="{'activeChild':tabChildActive == ($slots.tabsAfter ? (index+1) : index) }"
										:style="tabChildActive == ($slots.tabsAfter ? (index+1) : index) ? tabStyleTab : {}"
										v-bind:key="child.label"
										class="vs-tabs--li"
										@mouseover="tabHover = true"
										@mouseout="tabHover = false"
									>
										<button
											v-bind="child.$attrs"
											:style="tabStyleAlignIcon(child.icon)"
											class="vs-tabs--btn"
											type="button"
											@click="tabActiveChild(($slots.tabsAfter ? (index+1) : index))"
											v-on="child.$listeners"
										>
											<vs-icon
												v-if="child.icon"
												:icon-pack="child.iconPack"
												:icon="child.icon"
												:color="tabColor"
												class="vs-tabs--btn-icon"
											></vs-icon>
											<span v-if="child.label">{{ child.label }}</span>
										</button>

										<button
											v-if="child.tag"
											class="vs-tabs--btn-tag"
											@click="tabClickTag(child)"
										>
											<vs-icon
												:icon-pack="child.iconPack"
												:icon="child.tag"
												:color="child.tagColor"
											></vs-icon>
										</button>
									</li>
								</ul>
								<span
									:style="tabStylex"
									class="line-vs-tabs"
								/>
							</div>
						</div>
					</div>
					<vs-icon
						v-if="type=='alert'"
						:icon="closeIcon"
						:icon-pack="iconPack"
						class="vs-dialog-cancel vs-dialog-cancel--icon notranslate"
						@click.native="handleClose"
					/>
				</header> <!-- // slots  -->
				<div class="vs-dialog-text">
					<div
						:class="[`vs-tabs-${tabColor}`,`vs-tabs-position-${tabPosition}`, tabClass]"
						class="con-vs-tabs vs-tabs"
					>
						<div class="con-slot-tabs">
							<slot></slot>
							{{ text }}
						</div>
					</div>
				</div>
				<!-- footer buttons -->
				<slot
					name="footer"
					v-bind:dialog="this"
				>
					<footer v-if="(buttonsHidden?false:isPrompt||type=='confirm')">
						<vs-button
							class="vs-dialog-accept-button"
							:disabled="isValid=='none'?false:!isValid"
							:color="color"
							:type="buttonAccept"
							@click="acceptDialog"
						>{{ acceptText }}</vs-button>
						<vs-button
							class="vs-dialog-cancel-button"
							:text-color="'rgba(0,0,0,.5)'"
							:type="buttonCancel"
							@click="cancelClose"
						>{{ cancelText }}</vs-button>
					</footer>
					<footer v-if="(type=='alert'&&!isPrompt)">
						<vs-button
							class="vs-dialog-accept-button"
							:color="color"
							:type="buttonAccept"
							@click="acceptDialog"
						>{{ acceptText }}</vs-button>
					</footer>
				</slot>
			</div>
		</div>
	</transition>
</template>

<script>
import _color from "@assets/utils/color.js";

export default {
	name: "VsPromptTabsCustom",
	props: {
		color: {
			default: "primary",
			type: String,
		},
		active: {
			default: false,
			type: Boolean,
		},
		buttonAccept: {
			default: "filled",
			type: String,
		},
		buttonCancel: {
			default: "flat",
			type: String,
		},
		isValid: {
			default: "none",
			type: [Boolean, String],
		},
		buttonsHidden: {
			default: false,
			type: Boolean,
		},
		acceptText: {
			default: "Accept",
			type: String,
		},
		cancelText: {
			default: "Cancel",
			type: String,
		},
		iconPack: {
			default: "material-icons",
			type: String,
		},
		closeIcon: {
			default: "close",
			type: String,
		},
		text: {
			default: null,
			type: String,
		},
		title: {
			default: "Dialog",
			type: String,
		},
		type: {
			default: "alert",
			type: String,
		},
		parent: {
			default: null,
		},

		value: {
			default: 0,
			type: [Number, String],
		},
		tabColor: {
			default: "primary",
			type: String,
		},
		tabAlignment: {
			default: "left",
			type: String,
		},
		tabPosition: {
			default: "top",
			type: String,
		},
		tabClass: {
			default: "",
			type: String,
		},
		tabBackgroundHidden: {
			default: false,
			type: Boolean,
		},
	},
	data: () => ({
		isPrompt: true,
		fActive: false,
		parameters: null,

		tabTopx: "auto",
		tabHeightx: 2,
		tabHover: false,
		tabChildren: [],
		tabChildrenKeys: {},
		tabChildActive: 0,
		tabLeftx: 0,
		tabWidthx: 0,
		tabThese: false,
	}),
	computed: {
		styleHeader() {
			return {
				color: _color.getColor(this.color, 1),
			};
		},
		styleAfter() {
			return {
				background: _color.getColor(this.color, 1),
			};
		},

		/*tabChildrenNew: {
			cache: false,
			get() {
				//console.log("tabChildrenNew", this.tabChildren);
				return Object.values(this.tabChildren).filter(function(u) {
					console.log("tabChildrenNew", u);
					return !u.hasOwnProperty("placeholder");
				});
			},
		},*/
		tabChildrenNew() {
			/*console.log("tabChildrenNew", this.tabChildren);
			return this.tabChildren;*/
			/*return Object.values(this.tabChildren).filter(function(u) {
				console.log("tabChildrenNew", u);
				return !u.hasOwnProperty("placeholder");
			});*/
			return this.tabChildren.filter(function(u) {
				return !u.hasOwnProperty("placeholder");
			});
		},
		/*tabChildrenSlots() {
			return this.$children.filter(function(item) {
				return item && item.$vnode && item.$vnode.tag && item.$vnode.tag.indexOf("VsPromptTabCustom") >= 0;
			});
		},*/
		tabChildrenSlots: {
			cache: false,
			get() {
				return this.$children.filter(function(item) {
					return item && item.$vnode && item.$vnode.tag && item.$vnode.tag.indexOf("VsPromptTabCustom") >= 0;
				});
			},
		},
		tabStyleTab() {
			return {
				color: _color.getColor(this.tabColor, 1),
			};
		},
		tabStylex() {
			return {
				top: `${this.tabTopx}px`,
				left: `${this.tabLeftx}px`,
				width: `${this.tabWidthx}px`,
				height: `${this.tabHeightx}px`,
				background: `linear-gradient(30deg, ${_color.getColor(this.tabColor, 1)} 0%, ${_color.getColor(this.tabColor, 0.5)} 100%)`,
				boxShadow: `0px 0px 8px 0px ${_color.getColor(this.tabColor, 0.5)}`,
				transform: `scaleX(${this.tabThese ? 1.3 : 1})`,
			};
		},
	},
	watch: {
		active() {
			this.$nextTick(() => {
				if (this.active) {
					this.insertBody();
				}
			});
		},
		fActive() {
			this.$nextTick(() => {
				if (this.fActive) {
					this.insertBody();
				}
			});
		},
		value(index) {
			console.log("WATCH", index);
			const activeIndex = this.tabParseIndex(index);
			console.log("WATCHactive", activeIndex);
			this.tabActiveChild(activeIndex);
		},
	},
	created() {
		console.log("created", this.$children);
	},
	mounted() {
		console.log("mounted", this.$children);
		if (this.active && this.isPrompt) {
			this.insertBody();
		}
		this.fActive = this.active;
	},
	beforeDestroy() {
		console.log("beforeDestroy");
		// close the left open prompt
		let elx = this.$refs.con;
		let parentx = this.parent ? this.parent : document.body;
		if (elx) {
			console.log("beforeDestroy REMOVE");
			parentx.removeChild(elx);
		}
	},
	methods: {
		giveColor(color) {
			return _color.rColor(color);
		},
		acceptDialog() {
			let _this = this;
			if (!this.isPrompt) {
				this.accept ? this.accept(this.parameters) : null;
				this.fActive = false;
				this.$emit("update:active", false);
				this.$emit("accept", this.parameters);
			} else {
				if (this.isValid || this.isValid == "none") {
					this.accept ? this.accept() : null;
					this.fActive = false;
					this.$emit("update:active", false);
					this.$emit("accept", this.parameters);
				}
			}
		},
		rebound() {
			this.$refs.dialogx.classList.add("locked");
			setTimeout(() => {
				this.$refs.dialogx.classList.remove("locked");
			}, 200);
		},
		handleClose(event, con) {
			if (con) {
				if (event.target.className.indexOf("vs-dialog-dark") != -1 && this.type == "alert") {
					this.fActive = false;
					this.$emit("update:active", false);
				} else if (event.target.className.indexOf("vs-dialog-dark") != -1) {
					this.rebound();
				}
			} else {
				if (
					event
						? event.target.className.indexOf("vs-dialog-cancel") != -1
						: event
						? event.target.className.indexOf("vs-dialog-cancel--icon") != -1
						: false
				) {
					this.fActive = false;
					this.$emit("update:active", false);
				}
			}
			this.$emit("close");
		},
		cancelClose() {
			this.fActive = false;
			this.$emit("update:active", false);
			this.$emit("cancel");
			// this.$emit('cancel')
			this.cancel ? this.cancel(this.parameters) : null;
		},
		insertBody() {
			console.log("insertBody Bef", this.$children, this.tabChildrenNew);
			let elx = this.$refs.con;
			let parentx = this.parent ? this.parent : document.body;
			parentx.insertBefore(elx, parentx.firstChild);

			console.log("insertBody after", this.$children);

			const activeIndex = this.tabParseIndex(this.value);
			this.tabChildActive = activeIndex;
			this.$children.map((item, item_index) => {
				if (item && item.$vnode && item.$vnode.tag && item.$vnode.tag.indexOf("VsPromptTabCustom") >= 0) {
					if (this.tabPosition == "left" || this.tabPosition == "right") {
						item.vertical = true;
					}
				}
			});
			this.$nextTick(() => {
				this.tabActiveChild(activeIndex, true);
			});
		},

		tabClickTag(child) {
			this.$emit("click-tag", child);
		},
		tabStyleAlignIcon(icon) {
			return icon ? "display:flex;align-items:center" : "";
		},
		tabParseIndex(index) {
			console.log("tabParseIndex", index, this.tabChildrenSlots.length);
			let activeIndex = this.tabChildActive;
			/*if (index < 0) {
				activeIndex = 0;
			} else if (index >= this.$children.length) {
				activeIndex = this.$children.length - 1;
			} else if (typeof this.$children[index].$attrs.disabled === "undefined" || typeof this.$children[index].$attrs.disabled !== "undefined") {
				activeIndex = parseInt(index);
			}*/
			if (index < 0) {
				activeIndex = 0;
			} else if (index >= this.tabChildrenSlots.length) {
				activeIndex = this.tabChildrenSlots.length - 1;
			} else if (
				typeof this.tabChildrenSlots[index].$attrs.disabled === "undefined" ||
				typeof this.tabChildrenSlots[index].$attrs.disabled !== "undefined"
			) {
				activeIndex = parseInt(index);
			}
			if (activeIndex < 0) {
				activeIndex = 0;
			}
			return activeIndex;
		},
		tabActiveChild(index, initialAnimation) {
			console.log("activeChild", this.tabChildActive, index, this.$refs, this.$refs.li);
			if (!this.$refs || !this.$refs.li || !this.tabChildrenSlots || !this.tabChildrenSlots.length) {
				return;
			}

			initialAnimation = !!initialAnimation;
			const elem = this.$refs.li[this.$slots.tabsAfter ? index - 1 : index];
			if (this.tabChildActive == index && !initialAnimation) {
				this.tabThese = true;
				elem.classList.add("isActive");
				setTimeout(() => {
					elem.classList.remove("isActive");
					this.tabThese = false;
				}, 200);
			}

			/*this.$children.map((item, item_index) => {
				if (item_index != index && item && item.$vnode && item.$vnode.tag && item.$vnode.tag.indexOf("VsPromptTabCustom") >= 0) {
					console.log("TAB CH", item);
					if (item_index != index && item._name != "<VsButton>") {
						item.active = false;
					}
				}
			});*/
			this.tabChildrenSlots.map((item, item_index) => {
				if (item_index != index && item && item.$vnode && item.$vnode.tag && item.$vnode.tag.indexOf("VsPromptTabCustom") >= 0) {
					console.log("TAB CH", item);
					if (item_index != index && item._name != "<VsButton>") {
						item.active = false;
					}
				}
			});

			/*if (this.tabChildActive != index || !this.$children[index].active) {
				if (this.tabChildActive > index) {
					console.log("INVERT", this.$children[index].vertical);
					this.$children[index].invert = false;
					this.$children[this.tabChildActive].invert = true;
				} else {
					console.log("NOT INVERT", this.$children[index].vertical);
					this.$children[this.tabChildActive].invert = false;
					this.$children[index].invert = true;
				}
			}*/

			console.log("slots", this.tabChildrenSlots);
			console.log("isACtive", this.tabChildrenSlots[index].active, this.tabChildrenSlots[index]._uid);
			if (this.tabChildActive != index || !this.tabChildrenSlots[index].active) {
				if (this.tabChildActive > index) {
					console.log("INVERT", this.tabChildrenSlots[index].vertical);
					this.tabChildrenSlots[index].invert = false;
					this.tabChildrenSlots[this.tabChildActive].invert = true;
				} else {
					console.log("NOT INVERT", this.tabChildrenSlots[index].vertical);
					this.tabChildrenSlots[this.tabChildActive].invert = false;
					this.tabChildrenSlots[index].invert = true;
				}
			}

			//this.$children[index].active = true;
			this.tabChildrenSlots[index].active = true;
			this.tabChildActive = index;
			this.$emit("input", this.tabChildActive);

			if (this.tabPosition == "left" || this.tabPosition == "right") {
				//this.$children[index].vertical = true;
				this.tabChildrenSlots[index].vertical = true;
			}

			this.tabChangePositionLine(elem, initialAnimation);
		},
		tabChangePositionLine(elem, initialAnimation) {
			if (this.tabPosition == "left" || this.tabPosition == "right") {
				this.tabTopx = elem.offsetTop;
				this.tabHeightx = elem.offsetHeight;
				this.tabWidthx = 2;
			} else {
				//console.log("here", this.position);
				const update = () => {
					this.tabLeftx = elem.offsetLeft;
					this.tabWidthx = elem.offsetWidth;
					this.tabTopx = elem.offsetHeight + (elem.getBoundingClientRect().top - this.$refs.ul.getBoundingClientRect().top) - 3;
				};
				if (!initialAnimation) {
					update();
				} else {
					setTimeout(update, 100);
				}
			}
		},
	},
};
</script>
<style lang="scss">
.con-vs-dialog.con-vs-dialog-custom .vs-dialog header .con-title-after {
	display: flex;
	justify-content: space-between;
}
.con-vs-dialog.con-vs-dialog-custom .vs-dialog header .con-title-after .con-vs-tabs.vs-tabs {
	width: initial;
	align-self: center;
}
.con-vs-dialog.con-vs-dialog-custom .vs-dialog header .con-title-after .con-vs-tabs.vs-tabs ul.ul-tabs.vs-tabs--ul {
	-webkit-box-shadow: unset;
	box-shadow: unset;
}
</style>

